<template>
    <div class="row row--15 service-wrapper">
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
             v-for="(service, index) in serviceList"
             :key=index>
            <div :class="`card-box ${cardStyle} ${checkTextAlign}`"
                 data-aos="fade-up"
                 data-aos-delay="70">
                <div class="inner">
                    <div class="image">
                        <!-- <router-link to="/service-details">
                        </router-link> -->
                        <!-- <img :src="service.image" alt="card Images"/> -->
                    </div>
                    <div class="content">
                        <h4 class="title mb--20">
                            <!-- <router-link to="/service-details" v-html="service.title"/> -->
                            {{ service.title }}
                        </h4>
                        <p class="description b1 color-gray mb--0" v-html="service.description"/>
                        <!-- <router-link class="btn-default btn-small btn-border" to="/service-details">
                            Read More
                        </router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ServiceTwo',
        props: {
            cardStyle: {
                type: String
            },
            textAlign: {
                type: String,
                default: 'left'
            }
        },
        data() {
            return {
                serviceList: [
                    {
                        image: require('@/assets/images/service/service-01.jpg'),
                        title: 'Cloud Native DevOps',
                        description: 'Automate your infrastructure and software delivery pipeline. Build and deploy faster.'
                    },
                    {
                        image: require('@/assets/images/service/service-02.jpg'),
                        title: 'App Development',
                        description: 'Reach the largest audience with our cross-platform app development services.'
                    },
                    {
                        image: require('@/assets/images/service/service-03.jpg'),
                        title: 'Blockchain Technology',
                        description: 'Our Ethereum Virtual Machine (EVM) experts can write and audit smart contracts.'
                    },
                    {
                        image: require('@/assets/images/service/service-04.jpg'),
                        title: 'Generative AI',
                        description: 'Harness the power of AI to give your business a competitive edge.'
                    }
                ]
            }
        },
        computed: {
            checkTextAlign() {
                if (this.textAlign === 'left') return 'text-start';
                else if (this.textAlign === 'center') return 'text-center';
                else if (this.textAlign === 'end') return 'text-end';
                else return '';
            }
        }
    }
</script>